import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["variant", "sizeVariant", "rounded", "useContainerWidth", "children", "$css"];
import React from 'react';
import styled, { css } from 'styled-components';
import { COLORS, FONTS, TYPOGRAPHY } from '../../../themes';
import { focus, buttonFocusStyles, hoverMultiple, highContrastBorder, combineCss, flex, focusStyles, focusStylesError } from '../../../styling';
import LinkOrButton from '../../LinkOrButton';
var ButtonWrapper = /*#__PURE__*/styled(LinkOrButton).withConfig({
  displayName: "Button__ButtonWrapper",
  componentId: "sc-1k1xxgx-0"
})(["", " border-radius:", ";", ";box-sizing:border-box;cursor:pointer;display:inline-block;text-decoration:none;white-space:nowrap;", " &:disabled,&[disabled]{pointer-events:none;}", " ", " ", ""], FONTS.PRIMARY, function (_ref) {
  var $rounded = _ref.$rounded;
  return !$rounded ? "4px" : "100px";
}, highContrastBorder, flex(), function (_ref2) {
  var $size = _ref2.$size,
      $useContainerWidth = _ref2.$useContainerWidth,
      $variant = _ref2.$variant;

  switch ($size) {
    case 'small':
      return css(["font-size:", ";padding:", ";line-height:1;min-height:44px;width:", ";"], TYPOGRAPHY.S_SEMIBOLD, $variant === 'tertiary' ? '9px 12px' : '9px 24px', $useContainerWidth ? '100%' : 'unset');

    case 'xsmall':
      return css(["font-size:", ";padding:3px 24px;line-height:1;min-height:32px;width:", ";"], TYPOGRAPHY.S_SEMIBOLD, $useContainerWidth ? '100%' : 'unset');

    default:
      return css(["font-size:", ";padding:11px 16px;line-height:1;min-height:48px;width:", ";min-width:", ";"], TYPOGRAPHY.M_SEMIBOLD, $useContainerWidth ? '100%' : 'unset', $useContainerWidth || $variant === 'tertiary' ? 'unset' : '340px');
  }
}, function (_ref3) {
  var $variant = _ref3.$variant;

  switch ($variant) {
    case 'secondary':
      return css(["", " border:1px solid ", ";", " &:disabled,&[disabled]{background:none !important;color:", " !important;border:1px solid ", " !important;}"], focus(focusStyles), COLORS.PRIMARY_600, hoverMultiple([{
        prop: 'background',
        base: COLORS.WHITE,
        hover: COLORS.PRIMARY_100,
        active: COLORS.PRIMARY_200
      }, {
        prop: 'color',
        base: COLORS.PRIMARY_600,
        hover: COLORS.PRIMARY_600,
        active: COLORS.PRIMARY_600
      }]), COLORS.NEUTRAL_300, COLORS.NEUTRAL_300);

    case 'delete':
      return css(["", " border:1px solid ", ";", " &:disabled,&[disabled]{background:none !important;color:", " !important;border:1px solid ", " !important;}"], focus(css(["", ";color:", ";"], focusStylesError, COLORS.NEGATIVE_450)), COLORS.NEGATIVE_450, hoverMultiple([{
        prop: 'background',
        base: COLORS.WHITE,
        hover: COLORS.NEGATIVE_450,
        active: COLORS.NEGATIVE_100
      }, {
        prop: 'color',
        base: COLORS.NEGATIVE_450,
        hover: COLORS.WHITE,
        active: COLORS.NEGATIVE_450
      }]), COLORS.NEUTRAL_300, COLORS.NEUTRAL_300);

    case 'tertiary':
      return css(["border:1px solid transparent;", " ", " &:disabled,&[disabled]{background:none;color:", ";}"], hoverMultiple([{
        prop: 'background',
        base: 'none',
        hover: COLORS.PRIMARY_100,
        active: COLORS.PRIMARY_200
      }, {
        prop: 'color',
        base: COLORS.PRIMARY_600,
        hover: COLORS.PRIMARY_600,
        active: COLORS.PRIMARY_600
      }]), focus(focusStyles), COLORS.NEUTRAL_300);

    default:
      return css(["", " color:", ";", " &:disabled,&[disabled]{background:", " !important;}"], focus(css(["", ";background:", ";color:", ";"], buttonFocusStyles, COLORS.PRIMARY_500, COLORS.WHITE)), COLORS.WHITE, hoverMultiple([{
        prop: 'background',
        base: COLORS.PRIMARY_600,
        hover: COLORS.PRIMARY_500,
        active: COLORS.PRIMARY_700
      }]), COLORS.NEUTRAL_200);
  }
}, combineCss());

var Button = function Button(_ref4) {
  var _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'primary' : _ref4$variant,
      _ref4$sizeVariant = _ref4.sizeVariant,
      sizeVariant = _ref4$sizeVariant === void 0 ? 'regular' : _ref4$sizeVariant,
      _ref4$rounded = _ref4.rounded,
      rounded = _ref4$rounded === void 0 ? true : _ref4$rounded,
      _ref4$useContainerWid = _ref4.useContainerWidth,
      useContainerWidth = _ref4$useContainerWid === void 0 ? false : _ref4$useContainerWid,
      children = _ref4.children,
      $css = _ref4.$css,
      rest = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/React.createElement(ButtonWrapper, _extends({
    $size: sizeVariant,
    $useContainerWidth: useContainerWidth,
    $variant: variant,
    $rounded: rounded,
    $css: $css
  }, rest), children);
};

export default Button;